import {pipe, curry, isFunction} from './function'
import {compactMap, join} from './array'

export const split = curry((sep, str) => (isFunction(str && str.split) ? str.split(sep): []))

export const trim = str => (isFunction(str && str.trim) ? str.trim(): '')

export const upperCase = str => (isFunction(str && str.toUpperCase) ? str.toUpperCase(): '')

export const lowerCase = str => (isFunction(str && str.toLowerCase) ? str.toLowerCase(): '')

export const removeLeadingWhitespace = string => string.replace(/^\s+/i, '')

export const removeTrailingWhitespace = string => string.replace(/\s+$/i, '')

export const upperFirst = str =>
  (isFunction(str && str.slice) ? `${upperCase(str.slice(0, 1))}${lowerCase(str.slice(1))}`: '')

export const titleCase = pipe(split(/\s/g), compactMap(pipe(trim, upperFirst)), join(' '))

/**
 * |（パイプ）を<br />に変換してHTMLテキストとして返す
 * @param str
 * @returns {string}
 */
export const convertPipeToBrTag = (str = null) => {
  if (!str || str === '') return '';
  // HTMLコードを削除
  str = str.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, '');
  // BRタグに変換
  return str.replace(/[|]/g, '<br />');
};

/**
 * 日付（YYYYMMDDもしくはYYYYMM）を2018/01/01のフォーマットに変換
 * @param YYYYMMDD
 * @returns {*}
 */
export const formatDate = (YYYYMMDD = null, char = '/')=> {
  if (YYYYMMDD && typeof YYYYMMDD === 'string') {
    const length = YYYYMMDD.length;
    let date = null;
    if (4 <= length) {
      date = YYYYMMDD.substr(0, 4);
    }
    if (6 <= length) {
      date = date + char + YYYYMMDD.substr(4, 2);
    }
    if (8 <= length) {
      date = date + char + YYYYMMDD.substr(6, 2);
    }
    return date;
  } else {
    return null;
  }
};

/**
 * カタカナグレード名称をフォルダ使用可能名称に変換
 * @param str
 * @returns {string}
 */
export const convertKataToRome = (str)=> {
  // 全角スペースを半角スペースに変換
  str = (str + '').replace(/　/g, ' ');
  // 大文字を小文字にスペースをハイフンに変換
  str = str.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
  // ひらがなを全角カタカナに
  str = str.replace(/[\u3041-\u3096]/g, function(match) {
    var chr = match.charCodeAt(0) + 0x60;
    return String.fromCharCode(chr);
  });
  // 全角カタカナをローマ字に
  let strArr = [];
  let i, max;
  for (i = 0, max = str.length; i < max; i = i + 1) {
    const charCode = str.charCodeAt(i);
    if (charCode === 12450) {strArr.push('a');}
    else if(charCode === 12452) {strArr.push('i');}
    else if(charCode === 12454) {strArr.push('u');}
    else if(charCode === 12456) {strArr.push('e');}
    else if(charCode === 12458) {strArr.push('o');}
    else if(charCode === 12459) {strArr.push('ka');}
    else if(charCode === 12461) {strArr.push('ki');}
    else if(charCode === 12463) {strArr.push('ku');}
    else if(charCode === 12465) {strArr.push('ke');}
    else if(charCode === 12467) {strArr.push('ko');}
    else if(charCode === 12469) {strArr.push('sa');}
    else if(charCode === 12471) {strArr.push('si');}
    else if(charCode === 12473) {strArr.push('su');}
    else if(charCode === 12475) {strArr.push('se');}
    else if(charCode === 12477) {strArr.push('so');}
    else if(charCode === 12479) {strArr.push('ta');}
    else if(charCode === 12481) {strArr.push('ti');}
    else if(charCode === 12484) {strArr.push('tu');}
    else if(charCode === 12486) {strArr.push('te');}
    else if(charCode === 12488) {strArr.push('to');}
    else if(charCode === 12490) {strArr.push('na');}
    else if(charCode === 12491) {strArr.push('ni');}
    else if(charCode === 12492) {strArr.push('nu');}
    else if(charCode === 12493) {strArr.push('ne');}
    else if(charCode === 12494) {strArr.push('no');}
    else if(charCode === 12495) {strArr.push('ha');}
    else if(charCode === 12498) {strArr.push('hi');}
    else if(charCode === 12501) {strArr.push('fu');}
    else if(charCode === 12504) {strArr.push('he');}
    else if(charCode === 12507) {strArr.push('ho');}
    else if(charCode === 12510) {strArr.push('ma');}
    else if(charCode === 12511) {strArr.push('mi');}
    else if(charCode === 12512) {strArr.push('mu');}
    else if(charCode === 12513) {strArr.push('me');}
    else if(charCode === 12514) {strArr.push('mo');}
    else if(charCode === 12516) {strArr.push('ya');}
    else if(charCode === 12518) {strArr.push('yu');}
    else if(charCode === 12520) {strArr.push('yo');}
    else if(charCode === 12521) {strArr.push('ra');}
    else if(charCode === 12522) {strArr.push('ri');}
    else if(charCode === 12523) {strArr.push('ru');}
    else if(charCode === 12524) {strArr.push('re');}
    else if(charCode === 12525) {strArr.push('ro');}
    else if(charCode === 12527) {strArr.push('wa');}
    else if(charCode === 12530) {strArr.push('wo');}
    else if(charCode === 12531) {strArr.push('n');}
    else if(charCode === 12460) {strArr.push('ga');}
    else if(charCode === 12462) {strArr.push('gi');}
    else if(charCode === 12464) {strArr.push('gi');}
    else if(charCode === 12466) {strArr.push('ge');}
    else if(charCode === 12468) {strArr.push('go');}
    else if(charCode === 12470) {strArr.push('za');}
    else if(charCode === 12472) {strArr.push('zi');}
    else if(charCode === 12474) {strArr.push('zi');}
    else if(charCode === 12476) {strArr.push('ze');}
    else if(charCode === 12478) {strArr.push('zo');}
    else if(charCode === 12480) {strArr.push('da');}
    else if(charCode === 12482) {strArr.push('di');}
    else if(charCode === 12485) {strArr.push('du');}
    else if(charCode === 12487) {strArr.push('de');}
    else if(charCode === 12489) {strArr.push('do');}
    else if(charCode === 12496) {strArr.push('ba');}
    else if(charCode === 12499) {strArr.push('bi');}
    else if(charCode === 12502) {strArr.push('bu');}
    else if(charCode === 12505) {strArr.push('be');}
    else if(charCode === 12508) {strArr.push('bo');}
    else if(charCode === 12497) {strArr.push('pa');}
    else if(charCode === 12500) {strArr.push('pi');}
    else if(charCode === 12503) {strArr.push('pu');}
    else if(charCode === 12506) {strArr.push('pe');}
    else if(charCode === 12509) {strArr.push('po');}
    else if(charCode === 12532) {strArr.push('va');}
    else if(charCode === 12540) {strArr.push('-');}
    else if(charCode === 12449) {strArr.push('a');}
    else if(charCode === 12451) {strArr.push('i');}
    else if(charCode === 12453) {strArr.push('u');}
    else if(charCode === 12455) {strArr.push('e');}
    else if(charCode === 12457) {strArr.push('o');}
    else if(charCode === 12515) {strArr.push('ya');}
    else if(charCode === 12517) {strArr.push('yu');}
    else if(charCode === 12519) {strArr.push('yo');}
    else if(charCode === 12483) {strArr.push('tu');}
    else {strArr.push(str[i]);}
  }
  str = strArr.join('');
  // できるだけ半角にする
  str = (str + '').replace(/[！-～]/g, function(s) {
    return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
  });
  // 全角を削除
  str = (str + '').replace(/[^!-~\s]/g, '');
  // 半角英数以外を削除
  //str = (str + '').replace(/[^0-9a-zA-Z-//._]/g, '');
  // 先頭と末尾の空白と改行を削除
  str = (str + '').replace(/^[\s]*/, '').replace(/[\s]*$/, '');
  //
  return str;
};



// WEBPACK FOOTER //
// ./src/utils/string.js